import React, { Fragment, Component } from 'react';
import {
    ArrayField,
    Datagrid,
    Filter,
    List,
    Pagination,
    SelectInput,
    Show,
    SimpleShowLayout,
    TextField,
    NumberInput,
} from 'react-admin';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Icon from '@material-ui/icons/Bookmark';
export const LinTranscodeIcon = Icon;

export const LinTranscodeV2Filter = props => (
    <Filter {...props}>
        <SelectInput
            source="InputFormat"
            label={"InputFormat"}
            alwaysOn
            choices={[
                {id: '576i25', name: '576i25'},
                {id: '480i29.97', name: '480i29.97'},
                {id: '720p50', name: '720p50'},
                {id: '720p59.94', name: '720p59.94'},
                {id: '1080i25', name: '1080i25'},
                {id: '1080i29.97', name: '1080i29.97'},
                {id: '1080p50', name: '1080p50'},
                {id: '1080p59.94', name: '1080p59.94'},
                {id: '2160p50', name: '2160p50'},
                {id: '2160p59.94', name: '2160p59.94'}
            ]} />
        <SelectInput
            source="InputChroma"
            label={"InputChroma"}
            alwaysOn
            choices={[
                {id: '420', name: '420'},
                {id: '422', name: '422'}
            ]}
        />
        <SelectInput
            source="InputBit"
            label={"InputBit"}
            alwaysOn
            choices={[
                {id: '8', name: '8'},
                {id: '10', name: '10'}
            ]}
        />
        <SelectInput
            source="OutputCodec"
            label={"OutputCodec"}
            alwaysOn
            choices={[
                {id: 'H.265', name: 'H.265'},
                {id: 'H.264', name: 'H.264'},
                {id: 'H.264_HDT', name: 'H.264 HDT'},
                {id: 'MPEG2', name: 'MPEG2'},
            ]}
        />
        <NumberInput
            label={"ES Rate [Kbps]"}
            source="esRate"
            alwaysOn
        />
        <SelectInput
            source="OutputFormat"
            label={"OutputFormat"}
            alwaysOn
            choices={[
                {id: '576i25', name: '576i25'},
                {id: '480i29.97', name: '480i29.97'},
                {id: '720p50', name: '720p50'},
                {id: '720p59.94', name: '720p59.94'},
                {id: '1080i25', name: '1080i25'},
                {id: '1080i29.97', name: '1080i29.97'},
                {id: '1080p50', name: '1080p50'},
                {id: '1080p59.94', name: '1080p59.94'},
                {id: '2160p50', name: '2160p50'},
                {id: '2160p59.94', name: '2160p59.94'}
            ]} />
        <SelectInput
            source="Profile"
            label={"Profile"}
            alwaysOn
            choices={[
                {id: 'Main', name: 'Main'},
                {id: 'Main10', name: 'Main10'},
                {id: 'High', name: 'High'},
                {id: 'High10', name: 'High10'},
                {id: 'High_4:2:2_8bit', name: 'High_4:2:2_8bit'},
                {id: 'High_4:2:2_10bit', name: 'High_4:2:2_10bit'}
            ]}
        />
        <SelectInput
            source="SwVersion"
            label={"SwVersion"}
            alwaysOn
            choices={[
                {id: 'Latest', name: 'Latest'},
            ]}
        />

    </Filter>
);

const LinTranscodeExpand = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout>
            <ArrayField label="Test Results" source="Dut">
                <Datagrid>
                    <TextField
                        label="Synamedia PID"
                        source="VNNode"
                        sortable={false}/>
                    <TextField
                        label="CPU Architecture"
                        source="Cpu"
                        sortable={false}/>
                    <TextField
                        label="Density"
                        source="Density"
                        sortable={false}/>
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);

const LinTranscodePagination = props => <Pagination perPage={5} rowsPerPageOptions={[5, 10]} {...props} />;


class LinTranscodeV2List extends Component {
    render() {
        const props = this.props;
        return (
            <Fragment>
                <List title={<LinTranscodeTitle />}  {...props}
                      filters={<LinTranscodeV2Filter />}
                      filterDefaultValues={{
                          InputFormat: '1080i25',
                          OutputCodec: 'H.265',
                          esRate: 4000,
                          OutputFormat: '1080i25',
                          InputChroma: '420',
                          InputBit: '8'}}
                      bulkActions={false}
                      sort={{ field: 'SwVersion', order: 'DESC' }}
                      exporter={false}
                      pagination={<LinTranscodePagination />}
                >
                    <Datagrid expand={<LinTranscodeExpand />}>
                        <TextField
                            label="Output Codec"
                            source="outputcodec"
                            sortable={false} />
                        <TextField
                            label="ES Rate [kbps]"
                            source="esRate"
                            sortable={false} />
                        <TextField
                            label="Output Format"
                            source={"outputformat"}
                            sortable={false}/>
                        <TextField
                            label="Profile"
                            source="profile"
                            sortable={false} />
                        <TextField
                            label="SwVersion"
                            source={"SW"}
                            sortable={true}/>
                    </Datagrid>
                </List>
            </Fragment>
        );
    }
}


const LinTranscodeTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>Pretested 1st Screen Results V2</span>;
};


export default connect(
    undefined,
    { push }
)(LinTranscodeV2List);